export default "b9712dda34b420a5.svg"